const body = document.body;
const masthead = document.getElementById("masthead");
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;


window.addEventListener("scroll", function() {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 40) {
        body.classList.remove(scrollUp);
        return;

    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down

        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
    } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
});
